import { SearchBookingComponent } from './../../booking/components/search-booking.component';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { DriverAdminService } from './../../driveradmin/models/driveradmin.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ApplicationRouteURL } from './../../shared/config';
import { BookingOverview } from './../../booking/models/booking-overview.model';
import { VehicleOverviewModel } from './../../booking/models/vehicle-overview.model';
import { SearchBookingModel } from './../../booking/models/search-booking.model';
import { BookingService } from './../../booking/models/booking.service';
import { VehicleService } from './../../vehicle/models/vehicle.service';
import { SharedVehicleGroupService } from './../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { SchedulerBookingModel } from './../../booking/models/schedular-booking.model';
import { ButtonRadioDirective } from 'ng2-bootstrap/components/buttons';
import { AlertComponent } from 'ng2-bootstrap/components/alert';
const moment = require('moment');

@Component({
  selector: 'wego-booking-driver',
  template: require('../views/booking-driver.component.html'),
  styles: [require('../../booking/views/booking.component.css')],
  providers: [
    SharedVehicleGroupService,
    VehicleService,
    BookingService,
    DriverAdminService
  ]
})
export class BookingDriverComponent implements OnInit, OnDestroy {
  [x: string]: any;
  public isAllowInitialPaymentValue: boolean = false;
  public errorMessage: string;
  public refreshToken: string;
  public paymentPopup: any;
  searchBookingModel: SearchBookingModel;
  private vehicleOverviewList: VehicleOverviewModel[];
  filterVehicleOverviewList: VehicleOverviewModel[];
  private bookingOverviewModel: BookingOverview;
  private scheduledBookingModel: SchedulerBookingModel;
  swithBookingOverview: string = 'CALENDAR';
  apiErrorMsg: string;
  private sub: any;
  isLoading: boolean;
  private isNotEditable: boolean = false;
  isBanned: boolean;
  private version: string;
  isDriverHashID: boolean = false;
  isLicenceRequired: boolean;
  urlDriverUpdate: string;
  personMasterHashId: string;
  userBlockMessage: string;
  initialPaymentPopupTitle: string;
  public redirectUrl: any;
  public popupDescription: string;
  referenceID: string;
  private timezoneStartDateTime: string = '';

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('creditCardPaymentModal') public creditCardPaymentModal: any;

  popupMsg: string;
  popupTitle: string;
  private isSuccess: boolean = false;

  @ViewChild('alertModal') public alertModal: any;
  alertMsg: string;

  @ViewChild('searchBooking') public searchBooking: SearchBookingComponent;

  BOOKINGSTEP: any = {
    SEARCH: 1,
    VEHICLE: 2,
    CONFIRM: 3
  };

  CURRENTSTEP: string;

  get IsVehicleAvailableForUpdate(): boolean {
    if (
      this.vehicleOverviewList &&
      this.vehicleOverviewList.length > 0 &&
      this.searchBookingModel.isEditMode
    ) {
      return this.vehicleOverviewList.some(
        item =>
          this.searchBookingModel.vehicleHashId == item.vehicleHashID &&
          this.searchBookingModel.sharedVehicleGroupHashID ==
            item.sharedVehicleGroupHashID
      );
    } else {
      return true;
    }
  }

  constructor(
    private bookingService: BookingService,
    private driverAdminService: DriverAdminService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.urlDriverUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_DRIVER_PROFILE
    );
    if (
      this.authService.searchBookingModel &&
      this.authService.vehicleOverviewModel
    ) {
      this.searchBookingModel = this.authService.searchBookingModel;
      this.vehicleOverviewList = this.authService.vehicleOverviewModel;
      this.CURRENTSTEP = this.BOOKINGSTEP.VEHICLE;
      this.authService.searchBookingModel = null;
      this.authService.vehicleOverviewModel = null;
    } else {
      this.searchBookingModel = new SearchBookingModel();
      this.searchBookingModel.startDateTime = moment()
        .add('m', 5)
        .format('DD-MM-YYYY HH:mm');
      this.searchBookingModel.endDateTime = moment()
        .add('H', 1)
        .add('m', 5)
        .format('DD-MM-YYYY HH:mm');
      this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
      //this.CurrentDriverDetail();
      this.HandleBookingEdit();
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.successPopup.hide();
  }

  private HandleBookingEdit() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.referenceID = params['ref'] || '';
      let isRecurring = params['isRecurring'] || false;
      let version = params['v'] || '';
      this.ReloadPage(version);
      if (this.referenceID) {
        this.isLoading = true;
        this.bookingService
          .EditBookingDetail(this.referenceID, isRecurring)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              if (res.data) {
                this.searchBookingModel.isEditMode = true;
                this.searchBookingModel = res.data;
                this.searchBookingModel.isEditMode = true;
                this.searchBookingModel.isSpecialPeriod =
                  res.data.isSpecialPeriod;
                this.searchBookingModel.isRecurring =
                  isRecurring == 'true' ? true : false;
                this.searchBookingModel.isSpecialPeriod =
                  res.data.isSpecialPeriod;
                this.searchBookingModel.isRegularbooking = res.data
                  .contractTypeHashId
                  ? false
                  : true;
                this.searchBookingModel.startDateTime = res.data.startDateTime;
                this.searchBookingModel.endDateTime = res.data.endDateTime;
                console.log('this.searchBookingModel');
                console.log(this.searchBookingModel);
              } else {
                this.isNotEditable = true;
                this.alertMsg = res.error;
              }
            },
            (error: any) => {
              this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
              this.isLoading = false;
            }
          );
      }
      if (this.authService.IsDriver()) {
        this.CurrentDriverDetail();
      }
    });
  }

  public ReloadPage(version: string) {
    if (this.version != version) {
      this.version = version;
      this.searchBookingModel = new SearchBookingModel();
      this.searchBookingModel.startDateTime = moment()
        .add('m', 5)
        .format('DD-MM-YYYY HH:mm');
      this.searchBookingModel.endDateTime = moment()
        .add('H', 1)
        .add('m', 5)
        .format('DD-MM-YYYY HH:mm');
      this.searchBookingModel.recurringEndDateTime = '';
      if (this.searchBooking) {
        this.searchBooking.SetPickerValue(
          'SEARCH_FROM',
          this.searchBookingModel.startDateTime
        );
        this.searchBooking.SetPickerValue(
          'SEARCH_TO',
          this.searchBookingModel.endDateTime
        );
        this.searchBooking.ClearErrorModel();
      }
      this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
      this.vehicleOverviewList = [];
      this.filterVehicleOverviewList = [];
      this.bookingOverviewModel = new BookingOverview();
    }
  }

  public CurrentDriverDetail() {
    this.driverAdminService.GetCurrentDriverDetail().subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.data) {
          this.isBanned = res.data.isBanned;
          this.userBlockMessage = res.data.userBlockMessage;
          this.isLicenceRequired = res.data.isLicenceRequired;
          this.personMasterHashId = res.data.personMasterHashId;
          this.searchBookingModel.driverHashId = res.data.driverMasterHashId;
          this.searchBookingModel.isRecurringBookingAllow =
            res.data.isRecurringBookingAllow;
            this.searchBookingModel.startDateTime = res.data.startDateTime;
          this.timezoneStartDateTime = res.data.startDateTime;
          this.IsDriverHashID();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  private IsDriverHashID() {
    this.isDriverHashID = this.searchBookingModel.driverHashId ? true : false;
  }

  public AlertClose($event: any) {
    this.ClearBookingRecord();
    let urlBookingOverview = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING
    );
    this.router.navigate([urlBookingOverview]);
  }

  public ChangeStep(selected: any) {
    if (selected < this.CURRENTSTEP) this.CURRENTSTEP = selected;
  }

  public OnSearchBooking($event: any) {
    this.scheduledBookingModel = $event.ScheduledBookingModel;
    this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
  }

  public OnSearch($event: any) {
    this.searchBookingModel = $event.SearchModel;
    this.vehicleOverviewList = $event.VehicleOverview;
    this.CURRENTSTEP = this.BOOKINGSTEP.VEHICLE;
  }

  public Proceed($event: any) {}

  public OnUpdateVehicleOverView($event: any) {
    this.filterVehicleOverviewList = $event.FilterVehicleOverview;
  }

  public OnBook($event: any) {
    this.searchBookingModel.sharedVehicleGroupHashID =
      $event.SharedVehicleGroupHashID;
    this.searchBookingModel.vehicleHashId = $event.VehicleHashID;
    this.MakeProvisionalBooking();
  }

  public OnConfirmBooking($event: any) {
    this.searchBookingModel.bookingRemarks = $event.BookingRemarks;
    this.ConfirmProvisionalBooking();
  }

  public GetInitialPaymentValue(isAllowInitialPayment: any) {
    this.isAllowInitialPaymentValue = isAllowInitialPayment;
  }

  public ConfirmInitialPayment(): void {
    this.isLoading = true;
    if (this.isAllowInitialPaymentValue == false) {
      this.isLoading = false;
      const errorMessage = this.translate.instant('LblCheckAllowPayment');
      this.errorMessage = errorMessage + ':' + Date.now().toString();
    } else {
      this.searchBookingModel.isFromMobileSide = false;
      this.bookingService
        .StartInitialPayment(this.searchBookingModel)
        .subscribe(res => {
          if (res.data.redirectURL) {
            this.isLoading = false;
            window.location.href = res.data.redirectURL;
          } else {
            this.isLoading = false;
            this.creditCardPaymentModal.hide();
            this.popupMsg = res.error;
            this.ShowSuccessPopup();
          }
        });
    }
  }

  public OnCancelBooking($event: any) {
    this.CancelProvisionalBooking();
  }

  public OnCancelPayment($event: any) {
    this.CancelProvisionalBooking();
    let urlData = this.authService.GetURL(
      ApplicationRouteURL.URL_DASHBOARD_PAGE
    );

    this.router.navigate([urlData]);
  }

  private MakeProvisionalBooking() {
    this.isLoading = true;
    this.bookingService
      .MakeProvisionalBooking(this.searchBookingModel)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            if (!this.searchBookingModel.isRecurring)
              this.searchBookingModel.bookingMasterHashId = res.data;
            else this.searchBookingModel.reccuringID = res.data;
            this.GetBookingOverview();
          } else {
            this.popupTitle = this.translate.instant('LblWarning');
            this.alertMsg = res.error;
            this.ShowAlertPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private ConfirmProvisionalBookingWithoutRecurringPayment() {
    this.isLoading = true;
    this.bookingService
      .ConfirmProvisionalBooking(this.searchBookingModel)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant(res.data);
            this.isSuccess = true;
            this.ShowSuccessPopup();
          } else {
            this.popupTitle = this.translate.instant('LblWarning');
            this.popupMsg = res.error;
            this.isSuccess = false;
            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public CalculateBookingDuration(searchModel: BookingOverview) {
    let format = 'DD-MM-YYYY HH:mm';
    let stDate = moment(
      searchModel.booking.bookingStartDateTime,
      format
    ).toDate();
    let enDate = moment(
      searchModel.booking.bookingEndDateTime,
      format
    ).toDate();
    // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
    //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
    // }
    let diffMs = enDate - stDate;
    var diffDays = Math.floor(diffMs / 86400000); // days
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);

    if (diffDays > 0) {
      this.bookingOverviewModel.bookingDuration =
        diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
    } else if (diffDays == 0 && diffHrs > 0) {
      this.bookingOverviewModel.bookingDuration =
        diffHrs + ' Hours ' + diffMins + ' Min';
    } else if (diffDays == 0 && diffHrs == 0) {
      this.bookingOverviewModel.bookingDuration = diffMins + ' Min';
    }
    console.log(this.bookingOverviewModel.bookingDuration);
  }

  private ConfirmProvisionalBooking() {
    this.isLoading = true;
    this.bookingService
      .ConfirmRecurringPaymentBooking(
        this.searchBookingModel.bookingMasterHashId,
        this.searchBookingModel.reccuringID,
        this.referenceID
      )
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            if (res.data.askForInitialPayment) {
              this.popupDescription = this.translate.instant(
                'LblPaymentDescription',
                [res.data.initialPaymentAmount]
              );
              if (res.data.isPaymentSuccess || res.data.isFirstTimePayment) {
                this.initialPaymentPopupTitle = this.translate.instant(
                  'LblFirstBooking'
                );
              } else {
                this.initialPaymentPopupTitle = this.translate.instant(
                  'LblPaymentFailed'
                );
              }
              this.creditCardPaymentModal.show();
            } else {
              this.isLoading = true;
              this.ConfirmProvisionalBookingWithoutRecurringPayment();
            }
          } else {
            this.popupTitle = this.translate.instant('LblWarning');
            this.popupMsg = res.error;
            this.isSuccess = false;
            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private CancelProvisionalBooking() {
    this.isLoading = true;
    let referenceID = this.searchBookingModel.isRecurring
      ? this.searchBookingModel.reccuringID
      : this.searchBookingModel.bookingMasterHashId;
    this.bookingService
      .CancelProvisionalBooking(
        referenceID,
        this.searchBookingModel.isRecurring
      )
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          this.ClearBookingRecord();
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private GetBookingOverview() {
    this.isLoading = true;
    let referenceID = this.searchBookingModel.isRecurring
      ? this.searchBookingModel.reccuringID
      : this.searchBookingModel.bookingMasterHashId;
    this.bookingService
      .GetBookingOverview(referenceID, this.searchBookingModel.isRecurring)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (!res.error) {
            this.bookingOverviewModel = res.data;
            if (this.bookingOverviewModel.booking != null) {
              this.CalculateBookingDuration(this.bookingOverviewModel);
            }

            if (this.bookingOverviewModel.reccuringBooking != null) {
              this.bookingOverviewModel.bookingDuration = this.searchBookingModel.totalBookingDuration;
            }
            this.CURRENTSTEP = this.BOOKINGSTEP.CONFIRM;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private ClearBookingRecord() {
    this.isLoading = false;
    this.searchBookingModel = new SearchBookingModel();
    this.vehicleOverviewList = [];
    this.filterVehicleOverviewList = [];
    this.bookingOverviewModel = new BookingOverview();
    this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
    if (!this.isSuccess && !this.isNotEditable) {
      this.HandleBookingEdit();
    } else {
      if (this.isSuccess) {
        let urlBookingOverview = this.authService.GetURL(
          ApplicationRouteURL.URL_BOOKING_OVERVIEW
        );
        this.router.navigate([urlBookingOverview]);
      } else {
        let urlBookingOverview = this.authService.GetURL(
          ApplicationRouteURL.URL_BOOKING
        );
        this.router.navigate([urlBookingOverview]);
      }
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.HideSuccessPopup();
    this.ClearBookingRecord();
  }

  public ShowAlertPopup(): void {
    this.alertModal.show();
  }

  public HideAlertPopup(): void {
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    this.HideAlertPopup();
  }

  get diagnostic() {
    return JSON.stringify(this.scheduledBookingModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-driver/components/booking-driver.component.ts